// FlashNotificationContext.js
import { createContext } from 'react';

const FlashNotificationContext = createContext(null);

export default FlashNotificationContext;
